interface FileAttachmentIconProps {
  width?: number | string;
  height?: number | string;
  color?: string;
}

/** Document with a paperclip ("file-attachment-04"), used for the Documents action. */
const FileAttachmentIcon = ({
  width = 12,
  height = 12,
  color = "#0F0F0F",
}: FileAttachmentIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M10 3.5V3.4C10 2.55992 10 2.13988 9.83651 1.81901C9.6927 1.53677 9.46323 1.3073 9.18099 1.16349C8.86012 1 8.44008 1 7.6 1H4.4C3.55992 1 3.13988 1 2.81901 1.16349C2.53677 1.3073 2.3073 1.53677 2.16349 1.81901C2 2.13988 2 2.55992 2 3.4V8.6C2 9.44008 2 9.86012 2.16349 10.181C2.3073 10.4632 2.53677 10.6927 2.81901 10.8365C3.13988 11 3.55992 11 4.4 11H6.25M6.25 5.5H4M5.75 7.5H4M8 3.5H4M9 9V6.25C9 5.83579 9.33579 5.5 9.75 5.5C10.1642 5.5 10.5 5.83579 10.5 6.25V9C10.5 9.82843 9.82843 10.5 9 10.5C8.17157 10.5 7.5 9.82843 7.5 9V7"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FileAttachmentIcon;
